"use client";

import { PrismicNextImage } from "@prismicio/next";
import { motion } from "framer-motion";

export const MotionPrismicNextImage = motion.create(PrismicNextImage);
